import { render } from "./InputDemo.vue?vue&type=template&id=1ccf3fcb&scoped=true"
import script from "./InputDemo.vue?vue&type=script&lang=js"
export * from "./InputDemo.vue?vue&type=script&lang=js"

import "./InputDemo.vue?vue&type=style&index=0&id=1ccf3fcb&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccf3fcb"]])

export default __exports__